module.exports = __webpack_public_path__ + "static/media/fitness-centre.043ff84a.jpg";